module.exports = __webpack_public_path__ + "static/media/Eventos-para-empresas.2c160db7.JPG";